<template>
    <VJoyCheckboxGroup
        v-model:value="selectableModel"
        :options="options"
        direction="vertical"
        class="profile-edition__categorization-selection-list"
        :data-testid="dataTestid"
        @update:value="handleUpdateValue"
    >
        <template #checkbox="option">
            <div :data-testid="`${dataTestid}--${option.id}`" class="profile-edition__categorization-selection-list__item-content">
                {{ option.label }}
                <VJoyTag
                    v-if="isMainCategorySelected(option.id)"
                    :label="t('profile.creation.predictor.wizard.v2.details.expertise.main')"
                    variant="pending"
                    size="small"
                    class="checkbox__category-expertise responsive-content"
                />
            </div>
        </template>
    </VJoyCheckboxGroup>
</template>
<script setup lang="ts">
    import {computed, ref, watch} from 'vue';
    import {useTranslation} from '#imports';
    import {VJoyCheckboxGroup, VJoyTag, type CheckboxGroupOption} from '@maltjoy/core-vue';

    type CategorizationSelectionListItem = {
        categoryId: string;
        categoryLabel: string;
    };

    const emit = defineEmits<{
        'categorization-selection:update': [value?: string[]];
    }>();

    const props = withDefaults(
        defineProps<{
            categories: CategorizationSelectionListItem[];
            selectedCategories: string[];
            dataTestid?: string;
        }>(),
        {
            dataTestid: 'profile-edition-categorization-selection-list',
        },
    );

    // Composables
    const {t} = useTranslation();

    // Computed values
    const options = computed((): CheckboxGroupOption[] =>
        props.categories.map((prediction) => ({
            value: prediction.categoryId,
            id: prediction.categoryId,
            label: prediction.categoryLabel,
        })),
    );

    // Refs
    const selectableModel = ref(props.selectedCategories);

    // Watchers
    watch(
        () => props.categories,
        () => {
            selectableModel.value = [];
        },
    );

    // Handlers
    function handleUpdateValue(selectedCategories: string[]): void {
        emit('categorization-selection:update', selectedCategories);
    }

    function isMainCategorySelected(category: string): boolean {
        return selectableModel.value && selectableModel.value[0] === category;
    }
</script>
<style lang="scss">
    .profile-edition__categorization-selection-list {
        .joy-checkbox {
            display: flex;
            align-items: center;
        }

        &__item-content {
            display: flex;
            flex-direction: row;
            align-items: center;
            gap: var(--joy-core-spacing-2);
        }
    }
</style>
